import React, { useCallback, useEffect, useState } from "react";
import { IoCloseCircle } from "react-icons/io5";
import PropertyTypeSelector from "./PropertyTypeSelector";
import UploadComponent from "../../../Components/uploadproperty/uploadProperty";

import { FaCheck } from "react-icons/fa"; // For the check icon
import ServicesExcludingPrice from "./ServicesExcludingPrice/ServicesExcludingPrice";
import FoodDetails from "./FoodDetails/FoodDetails";
import ContractForm from "./ContractForm/ContractForm";
import PropertyFeatures from "./AmenitiesSection/PropertyFeatures";
import OwnershipPriceDetails from "./OwnershipPriceDetails/OwnershipPriceDetails";
import useCustomNavigate from "../../../hooks/useCustomNavigate";
import { getUserData } from "../../../Utils/localStorageUtils";
import { convertToFormData } from "../../../Utils/convertToFormData";
import { createProperty } from "../../../services/propertyService";
import { useToast } from "../../../hooks/useToast";
import PropertyLocationForm from "./LocationForm/PropertyLocationForm";
const months = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];


const AddPropertySection = ({ refs }) => {

  const { showSuccess, showError } = useToast();
  const { goTo } = useCustomNavigate()
  // State for loading and error
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");




  const [formData, setFormData] = useState({

    basicDetails: {
      lookingTo: "Sell", // For "I'm Looking To"
      propertyType: "Residential", // For "What kind of property do you have?"
      officeType: "",// New key for office type selection
      retailLocationInside: {}
    },


    locationDetails: {
      searchLocation: "",
      city: "",
      locality: "",
      subLocality: "",
      apartmentSociety: "",
      houseDetails: "",
    },


    aboutProperty: {

      roomDetails: {
        bedrooms: "",
        bathrooms: "",
        balconies: "",
      },
      areaDetails: {
        carpetArea: "",
        carpetAreaUnit: "sq.ft",
        buildupArea: "",
        buildupAreaUnit: "sq.ft",
        superBuildUpArea: "",
        superBuildUpAreaUnit: "sq.ft",
        plotArea: "",
        plotAreaUnit: "sq.ft"
      },
      roadDetails: {      // New object for road width and unit
        roadWidth: "",
        roadWidthUnit: "sq.ft", // Default unit for road width
      },
      propertyFacing: "North",  // Default value
      otherRooms: [], // Initialize as an empty array to hold the selected rooms
      furnishings: {
        status: "", // Furnishing status (Furnished, Semi-Furnished, Un-Furnished)
        features: {
          light: "", // Light details
          fans: "",
          ac: "",
          tv: "",
          geyser: "",
          beds: "",
          wardrobe: "",
          otherItems: [], // For checkbox items like Sofa, Washing Machine, etc.
        },
      },
      floorDetails: {
        totalFloor: "", // Value entered for Total Floor
        propertyOnFloor: "" // Value selected for Property On Floor
      },
      parking: {
        coveredParking: "",  // New field for covered parking
        openParking: "",     // New field for open parking
      },

      availabilityStatus: "",
      possessionBy: {
        expectedBy: '',
        month: ''
      },

      availableFrom: "",
      willingToRentOutTo: [],
      suitableFor: {
        students: false,
        workingprofessionals: false
      },

      RoomOccupancy: "",
      RoomType: "",
      capacityAvailability: {
        totalBeds: "",
        features: []
      },
      constructionDetails: {
        floorsAllowed: ""
      },
      availableFor: "",
      propertyDimensions: {
        length: "",
        breadth: ""
      },
      boundaryWallStatus: "",
      openSides: "",
      constructionDone: "",

      CornerProperty: false
    },

    // upload
    mediaFiles: [], // Add a new key for files

    pricingAndOthers: {
      rentDetails: {
        expectedRent: "",
        maintenance: "",
        maintenanceUnit: "Monthly",
        bookingAmount: "",
        membershipCharge: "",
        priceNegotiable: false,
        electricityWaterExclude: false,

      },
      securityDeposit: {
        type: "",
        depositValue: "",
        noOfMonths: "",
      },
      totalPriceIncludes: [],
      OwnershipPriceDetails: {},
      PropertyFeatures: {}
    },
  });


  const [isYearSelected, setIsYearSelected] = useState(true);
  const [selectedYear, setSelectedYear] = useState('');




  const handleYearChange = (e) => {
    const value = e.target.value;
    const currentYear = new Date().getFullYear();

    // Reset the month when year is changed
    setFormData(prevState => ({
      ...prevState,
      aboutProperty: {
        ...prevState.aboutProperty,
        possessionBy: {
          ...prevState.aboutProperty.possessionBy,
          expectedBy: value, // Update the selected year
          month: '' // Reset month when year is changed
        }
      }
    }));

    // Show month dropdown if year is 2025 or any future year
    if (parseInt(value) >= currentYear) {
      setIsYearSelected(true);
    } else {
      setIsYearSelected(false);
    }

    setSelectedYear(value); // Set the selected year
  };



  // Filter months based on whether the year is the current year or future years
  const filterMonths = () => {
    const currentDate = new Date();
    const currentMonthIndex = currentDate.getMonth(); // Get the current month index (0 = January)
    if (selectedYear === new Date().getFullYear().toString()) {
      // If it's the current year, return months starting from the current month
      return months.slice(currentMonthIndex); // Show current and future months
    } else {
      // If it's a future year (2025 or later), return all months
      return months;
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    const fields = name.split(".");

    setFormData((prevState) => {
      let updatedState = { ...prevState };
      let currentSection = updatedState;

      // Iterate through the fields (except the last one) and navigate through the object structure
      for (let i = 0; i < fields.length - 1; i++) {
        if (!currentSection[fields[i]]) {
          currentSection[fields[i]] = {};  // If the field doesn't exist, create it
        }
        currentSection = currentSection[fields[i]];  // Move deeper
      }

      // Update the last field with the new value
      currentSection[fields[fields.length - 1]] = value || "";

      return updatedState;
    });
  };





  const handleChange1 = (e) => {
    const { name, value } = e.target;
    const [section, field, subfield] = name.split("."); // Split the name to determine the section and field

    if (field === "lookingTo" && value === "PG") {
      setFormData((prevState) => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          lookingTo: value,
          propertyType: "Residential"
        },
      }));
    }
    else {
      setFormData((prevState) => {
        // Access the nested fields safely and update the value accordingly
        const updatedSection = { ...prevState[section] };
        if (subfield) {
          updatedSection[field] = {
            ...updatedSection[field],
            [subfield]: value,
          };
        } else {
          updatedSection[field] = value;
        }

        return {
          ...prevState,
          [section]: updatedSection,
        };
      });
    }
  };



  const SellResidential = [
    { key: "flat_apartment", value: "Flat/Apartment", description: "A unit in a multi-story building", icon: "🏢" },
    { key: "independent_villa", value: "Independent House/Villa", description: "A standalone house with its own land", icon: "🏡" },
    { key: "independent_builder", value: "Independent/Builder Floor", description: "Separate floors in a house", icon: "🏠" },
    { key: "plot_land", value: "Plot/Land", description: "A piece of land for construction or investment", icon: "🌍" },
    { key: "studio_apartment", value: "1 RK / Studio Apartment", description: "A compact unit with one room and kitchen", icon: "🛏️" },
    { key: "serviced_apartment", value: "Serviced Apartment", description: "Furnished apartment with services", icon: "🏨" },
    { key: "farm_house", value: "Farm House", description: "A house in a rural area", icon: "🌾" },
    { key: "other", value: "Other", description: "Any other type of property", icon: "❓" },
  ];

  const SellCommercial = [
    { key: "office", value: "Office", description: "Commercial office space", icon: "🏢" },
    { key: "retail", value: "Retail", description: "Retail space", icon: "🏪" },
    { key: "plot_land", value: "Plot/Land", description: "Commercial land", icon: "🌍" },
    { key: "storage", value: "Storage", description: "Warehouse or storage", icon: "🏗️" },
    { key: "industry", value: "Industry", description: "Industrial property", icon: "🏭" },
    { key: "hospitality", value: "Hospitality", description: "Hotels or resorts", icon: "🏨" },
    { key: "other", value: "Other Commercial", description: "Other commercial property", icon: "❓" },
  ];





  const PG = [
    { key: "pg", value: "PG", description: "Paying Guest accommodation", icon: "🏠" },
  ];


  const AGRICULTURE = [
    { key: "plot_land", value: "Plot/Land", description: "Paying Guest accommodation", icon: "🏠" },
  ];

  const getOptions = () => {
    if (formData.basicDetails.lookingTo === "PG") {
      return PG;
    }
    else if (formData?.basicDetails?.propertyType === "agriculture") {
      return AGRICULTURE;
    }
    else if (formData.basicDetails.lookingTo === "Sell" && formData.basicDetails.propertyType === "Residential") {
      return SellResidential;
    } else if (formData.basicDetails.lookingTo === "Sell" && formData.basicDetails.propertyType === "Commercial") {
      return SellCommercial;
    } else if (formData.basicDetails.lookingTo === "Rent / Lease") {
      return formData.basicDetails.propertyType === "Residential" ? SellResidential : SellCommercial;
    }
    return [];
  };



  const handlePropertyTypeChange = useCallback((selectedOption) => {
    setFormData((prevState) => {
      if (prevState?.basicDetails?.additionalOption?.key !== selectedOption.key) {
        return {
          ...prevState,
          basicDetails: {
            ...prevState.basicDetails, // Preserve other fields in basicDetails
            additionalOption: selectedOption
          },
        };
      }
      return prevState; // Prevent update if selected option is same as the previous one
    });
  }, []);



  // Generate the floor options dynamically based on Total Floor
  const totalFloors = parseInt(formData?.aboutProperty?.floorDetails?.totalFloor, 10);
  const floorOptions = [
    "Basement",
    "Lower Ground",
    "Ground",
    ...Array.from({ length: totalFloors }, (_, index) => `${index + 1} Floor`), // Dynamic floor options based on Total Floor
  ];


  const kindOffice = [
    { key: "bare_shell_office", value: "Bare Shell Office", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "co_working_office", value: "Co-Working Office", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "ready_to_move_office", value: "Ready to move office space", description: "Paying Guest accommodation", icon: "🏠" },
  ]


  const spaceTypes = [
    { key: "commericial_shop", value: "Commericial Shop", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "commericial_showrooms", value: "Commericial Showrooms", description: "Paying Guest accommodation", icon: "🏠" },
  ]

  const shopInsides = [
    { key: "mall", value: "Mall", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "commercial_project", value: "Commercial Project", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "residential_project", value: "Residential Project", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "retail_complex", value: "Retail Complex/Building", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "market_high_street", value: "Market / High Street", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "others", value: "Others", description: "Paying Guest accommodation", icon: "🏠" },
  ];



  // select plot_land

  const plotLandTypes = [
    { key: "commercial_land", value: "Commercial Land", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "industrial_land", value: "Industrial Land", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "agricultural_farm_land", value: "Agricultural / Farm Land", description: "Paying Guest accommodation", icon: "🏠" },
  ];

  // select industry
  const industryTypes = [
    { key: "ware_house", value: "Ware House", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "manufacturing", value: "Manufacturing", description: "Paying Guest accommodation", icon: "🏠" },
  ];

  // select storage
  const storageTypes = [
    { key: "factory", value: "Factory", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "cold_storage", value: "Cold Storage", description: "Paying Guest accommodation", icon: "🏠" },
  ];

  // select hospitality
  const hospitalityTypes = [
    { key: "hotel_resorts", value: "Hotel / Resorts", description: "Paying Guest accommodation", icon: "🏠" },
    { key: "guest_house_banquet_halls", value: "Guest House / Banquet-Halls", description: "Paying Guest accommodation", icon: "🏠" },
  ];


  const handleFileUpdate = (newFiles) => {
    setFormData((prev) => ({
      ...prev,
      mediaFiles: newFiles,
    }));
  };



  const amenities = [
    "Laundry",
    "Electricity",
    "Water",
    "Wifi",
    "Housekeeping",
    "DTH",
    "None of the above",
  ];



  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting Property Data:", formData);

    setIsLoading(true); // Start loading
    setError(""); // Clear previous errors

    const payload = new FormData();

    // Append other fields
    payload.append('basicDetails', JSON.stringify(formData.basicDetails));
    payload.append('locationDetails', JSON.stringify(formData.locationDetails));
    payload.append('aboutProperty', JSON.stringify(formData.aboutProperty));
    payload.append('pricingAndOthers', JSON.stringify(formData.pricingAndOthers));

    // Create a new array to hold categories
    const mediaCategories = [];

    // Append media files with categories
    formData.mediaFiles.forEach(({ file, category }) => {
      payload.append('mediaFiles', file); // Binary file upload
      mediaCategories.push(category); // Extract category and push it to the array
    });


    // Append the extracted categories array as a JSON string
    payload.append('mediaCategories', JSON.stringify(mediaCategories));


    // Append `postedBy` field
    const userId = getUserData()?._id || "default_user_id";
    payload.append('postedBy', userId);

    try {
      const response = await createProperty(payload); // Call the API
      if (response.success) {
        showSuccess("Property successfully added!"); // Show success toast
        goTo("/"); // Redirect after success
      } else {
        showError("Failed to add property. Please try again."); // Show error toast
        setError("Failed to add property. Please try again.");
      }
    } catch (err) {
      console.error("Error adding property:", err);
      showError("An error occurred while adding the property. Please try again."); // Show error toast
      setError("An error occurred while adding the property. Please try again.");
    } finally {
      setIsLoading(false); // Stop loading
    }
  };





  return (
    <div className="p-6 bg-white shadow-md mx-auto max-w-4xl rounded-md "
    >
      <h2 className="text-2xl font-bold mb-6">Add Property</h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Section 1: Basic Details */}
        <fieldset
          ref={refs.basicDetailsRef}
          className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Basic Details</legend>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">I'm Looking To</label>
              <select
                name="basicDetails.lookingTo"
                value={formData.basicDetails.lookingTo}
                onChange={handleChange1}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="Sell">Sell</option>
                <option value="Rent / Lease">Rent / Lease</option>
                <option value="PG">PG</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">What kind of property do you have?</label>
              <select
                name="basicDetails.propertyType"
                value={formData.basicDetails.propertyType}
                onChange={handleChange1}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                disabled={formData.basicDetails.lookingTo === "PG"}
              >
                <option value="Residential">Residential</option>
                <option value="Commercial">Commercial</option>
                <option value="agriculture">Agriculture</option>
              </select>
            </div>
          </div>
          <PropertyTypeSelector
            options={getOptions()}
            onSelectionChange={handlePropertyTypeChange}
          />


          {(formData.basicDetails.lookingTo !== "PG" && formData.basicDetails.propertyType == "Commercial" && formData.basicDetails?.additionalOption?.key == "office") &&
            <div>
              <label htmlFor="" className="block text-md font-medium text-black">What kind of office is it?</label>
              <div className="flex flex-wrap gap-4 p-4">
                {kindOffice.map((option) => (
                  <button
                    type="button"
                    key={option.key}
                    onClick={() => {
                      // Update officeType in formData
                      setFormData((prevData) => ({
                        ...prevData,
                        basicDetails: {
                          ...prevData.basicDetails,
                          officeType: option, // Set the office type key
                        },
                      }));
                    }}
                    className={`px-4 py-2 rounded border transition-all ${formData.basicDetails?.officeType?.key === option.key
                      ? "bg-green-500 text-white border-green-500"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                      }`}
                  >
                    {option.value}
                  </button>
                ))}
              </div>
            </div>
          }


          {(formData.basicDetails.lookingTo !== "PG" && formData.basicDetails.propertyType == "Commercial" && formData.basicDetails?.additionalOption?.key == "retail") &&
            <>
              <div>
                <label htmlFor="" className="block text-md font-medium text-black">What type of space do you have?</label>
                <div className="flex flex-wrap gap-4 p-4">
                  {spaceTypes.map((option) => (
                    <button
                      type="button"
                      key={option.key}
                      onClick={() => {
                        // Update officeType in formData
                        setFormData((prevData) => ({
                          ...prevData,
                          basicDetails: {
                            ...prevData.basicDetails,
                            retailSpaceType: option, // Set the office type key
                          },
                        }));
                      }}
                      className={`px-4 py-2 rounded border transition-all ${formData.basicDetails?.retailSpaceType?.key === option.key
                        ? "bg-green-500 text-white border-green-500"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                        }`}
                    >
                      {option.value}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label htmlFor="" className="block text-md font-medium text-black">Your Shop is located inside?</label>
                <div className="flex flex-wrap gap-4 p-4">
                  {shopInsides.map((option) => (
                    <button
                      type="button"
                      key={option.key}
                      onClick={() => {
                        // Update officeType in formData
                        setFormData((prevData) => ({
                          ...prevData,
                          basicDetails: {
                            ...prevData.basicDetails,
                            retailLocationInside: option, // Set the office type key
                          },
                        }));
                      }}
                      className={`px-4 py-2 rounded border transition-all ${formData.basicDetails?.retailLocationInside?.key === option.key
                        ? "bg-green-500 text-white border-green-500"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                        }`}
                    >
                      {option.value}
                    </button>
                  ))}
                </div>
              </div>
            </>
          }


          {(formData.basicDetails.lookingTo !== "PG" && formData.basicDetails.propertyType == "Commercial" && formData.basicDetails?.additionalOption?.key == "plot_land") &&
            <>
              <div>
                <label htmlFor="" className="block text-md font-medium text-black">What type of plot/land is it?</label>
                <div className="flex flex-wrap gap-4 p-4">
                  {plotLandTypes.map((option) => (
                    <button
                      type="button"
                      key={option.key}
                      onClick={() => {
                        // Update officeType in formData
                        setFormData((prevData) => ({
                          ...prevData,
                          basicDetails: {
                            ...prevData.basicDetails,
                            plotLandType: option, // Set the office type key
                          },
                        }));
                      }}
                      className={`px-4 py-2 rounded border transition-all ${formData.basicDetails?.plotLandType?.key === option.key
                        ? "bg-green-500 text-white border-green-500"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                        }`}
                    >
                      {option.value}
                    </button>
                  ))}
                </div>
              </div>
            </>
          }



          {(formData.basicDetails.lookingTo !== "PG" && formData.basicDetails.propertyType == "Commercial" && formData.basicDetails?.additionalOption?.key == "storage") &&
            <>
              <div>
                <label htmlFor="" className="block text-md font-medium text-black">What kind of Storage is it?</label>
                <div className="flex flex-wrap gap-4 p-4">
                  {storageTypes.map((option) => (
                    <button
                      type="button"
                      key={option.key}
                      onClick={() => {
                        // Update officeType in formData
                        setFormData((prevData) => ({
                          ...prevData,
                          basicDetails: {
                            ...prevData.basicDetails,
                            storageType: option, // Set the office type key
                          },
                        }));
                      }}
                      className={`px-4 py-2 rounded border transition-all ${formData.basicDetails?.storageType?.key === option.key
                        ? "bg-green-500 text-white border-green-500"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                        }`}
                    >
                      {option.value}
                    </button>
                  ))}
                </div>
              </div>
            </>
          }


          {(formData.basicDetails.lookingTo !== "PG" && formData.basicDetails.propertyType == "Commercial" && formData.basicDetails?.additionalOption?.key == "industry") &&
            <>
              <div>
                <label htmlFor="" className="block text-md font-medium text-black">What kind of industry is it?</label>
                <div className="flex flex-wrap gap-4 p-4">
                  {industryTypes.map((option) => (
                    <button
                      type="button"
                      key={option.key}
                      onClick={() => {
                        // Update officeType in formData
                        setFormData((prevData) => ({
                          ...prevData,
                          basicDetails: {
                            ...prevData.basicDetails,
                            industryType: option, // Set the office type key
                          },
                        }));
                      }}
                      className={`px-4 py-2 rounded border transition-all ${formData.basicDetails?.industryType?.key === option.key
                        ? "bg-green-500 text-white border-green-500"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                        }`}
                    >
                      {option.value}
                    </button>
                  ))}
                </div>
              </div>
            </>
          }


          {(formData.basicDetails.lookingTo !== "PG" && formData.basicDetails.propertyType == "Commercial" && formData.basicDetails?.additionalOption?.key == "hospitality") &&
            <>
              <div>
                <label htmlFor="" className="block text-md font-medium text-black">What kind of hospitalityType is it?</label>
                <div className="flex flex-wrap gap-4 p-4">
                  {hospitalityTypes.map((option) => (
                    <button
                      type="button"
                      key={option.key}
                      onClick={() => {
                        // Update officeType in formData
                        setFormData((prevData) => ({
                          ...prevData,
                          basicDetails: {
                            ...prevData.basicDetails,
                            hospitalityType: option, // Set the office type key
                          },
                        }));
                      }}
                      className={`px-4 py-2 rounded border transition-all ${formData.basicDetails?.hospitalityType?.key === option.key
                        ? "bg-green-500 text-white border-green-500"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                        }`}
                    >
                      {option.value}
                    </button>
                  ))}
                </div>
              </div>
            </>
          }




        </fieldset>



        <PropertyLocationForm refs={refs} formData={formData} setFormData={setFormData} />



        {/* Section 3: Tell us about your property */}
        <fieldset
          ref={refs.propertyProfileRef}
          className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Tell us about your property</legend>

          {(formData?.basicDetails?.additionalOption?.key !== "plot_land" &&
            formData?.basicDetails?.additionalOption?.key !== "other" &&
            formData?.basicDetails?.propertyType === "Residential") && <div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">Add Room Details</label>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">No. of Bedrooms</label>
                  <input
                    type="number"
                    name="aboutProperty.roomDetails.bedrooms"
                    value={formData.aboutProperty?.roomDetails?.bedrooms || ""}
                    onChange={handleChange1}
                    placeholder="Enter the number of bedrooms"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">No. of Bathrooms</label>
                  <input
                    type="number"
                    name="aboutProperty.roomDetails.bathrooms"
                    value={formData.aboutProperty?.roomDetails?.bathrooms || ""}
                    onChange={handleChange1}
                    placeholder="Enter the number of bathrooms"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">No. of Balconies</label>
                  <input
                    type="number"
                    name="aboutProperty.roomDetails.balconies"
                    value={formData.aboutProperty?.roomDetails?.balconies || ""}
                    onChange={handleChange1}
                    placeholder="Enter the number of balconies"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                </div>
              </div>


            </div>
          }


          {formData?.basicDetails?.lookingTo !== "PG" && <div className="mb-8">
            <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">Add Area Details</label>
            {(formData?.basicDetails?.additionalOption?.key == "plot_land" || formData?.basicDetails?.additionalOption?.key == "other") ?
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                <div className="flex items-center">
                  <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700">Plot Area</label>
                    <input
                      type="number"
                      name="aboutProperty.areaDetails.plotArea"
                      value={formData.aboutProperty?.areaDetails?.plotArea || ""}
                      onChange={handleChange1}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      placeholder="Enter Plot Area"
                    />
                  </div>
                  <div className="ml-2 w-32">
                    <label className="block text-sm font-medium text-gray-700">Unit</label>
                    <select
                      name="aboutProperty.areaDetails.plotAreaUnit"
                      value={formData.aboutProperty?.areaDetails?.plotAreaUnit || "sq.ft"}
                      onChange={handleChange1}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                      <option value="sq.ft">sq.ft</option>
                      <option value="sq.yards">sq.yards</option>
                      <option value="m²">m²</option>
                      <option value="acres">acres</option>
                    </select>
                  </div>
                </div>
              </div>
              :

              <>
                <p>At least one area type mandatory</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                  <div className="flex items-center">
                    <div className="w-full">
                      <label className="block text-sm font-medium text-gray-700">Carpet Area</label>
                      <input
                        type="number"
                        name="aboutProperty.areaDetails.carpetArea"
                        value={formData.aboutProperty?.areaDetails?.carpetArea || ""}
                        onChange={handleChange1}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        placeholder="Enter Carpet Area"
                      />
                    </div>
                    <div className="ml-2 w-32">
                      <label className="block text-sm font-medium text-gray-700">Unit</label>
                      <select
                        name="aboutProperty.areaDetails.carpetAreaUnit"
                        value={formData.aboutProperty?.areaDetails?.carpetAreaUnit || "sq.ft"}
                        onChange={handleChange1}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      >
                        <option value="sq.ft">sq.ft</option>
                        <option value="sq.yards">sq.yards</option>
                        <option value="m²">m²</option>
                        <option value="acres">acres</option>
                      </select>
                    </div>
                  </div>

                  <div className="flex items-center">
                    <div className="w-full">
                      <label className="block text-sm font-medium text-gray-700">Buildup Area</label>
                      <input
                        type="number"
                        name="aboutProperty.areaDetails.buildupArea"
                        value={formData.aboutProperty?.areaDetails?.buildupArea || ""}
                        onChange={handleChange1}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        placeholder="Enter Buildup Area"
                      />
                    </div>
                    <div className="ml-2 w-32">
                      <label className="block text-sm font-medium text-gray-700">Unit</label>
                      <select
                        name="aboutProperty.areaDetails.buildupAreaUnit"
                        value={formData.aboutProperty?.areaDetails?.buildupAreaUnit || "sq.ft"}
                        onChange={handleChange1}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      >
                        <option value="sq.ft">sq.ft</option>
                        <option value="sq.yards">sq.yards</option>
                        <option value="m²">m²</option>
                        <option value="acres">acres</option>
                      </select>
                    </div>
                  </div>

                  <div className="flex items-center">
                    <div className="w-full">
                      <label className="block text-sm font-medium text-gray-700">Super Build-up Area</label>
                      <input
                        type="number"
                        name="aboutProperty.areaDetails.superBuildUpArea"
                        value={formData.aboutProperty?.areaDetails?.superBuildUpArea || ""}
                        onChange={handleChange1}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        placeholder="Enter Super Build-up Area"
                      />
                    </div>
                    <div className="ml-2 w-32">
                      <label className="block text-sm font-medium text-gray-700">Unit</label>
                      <select
                        name="aboutProperty.areaDetails.superBuildUpAreaUnit"
                        value={formData.aboutProperty?.areaDetails?.superBuildUpAreaUnit || "sq.ft"}
                        onChange={handleChange1}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      >
                        <option value="sq.ft">sq.ft</option>
                        <option value="sq.yards">sq.yards</option>
                        <option value="m²">m²</option>
                        <option value="acres">acres</option>
                      </select>
                    </div>
                  </div>
                </div>
              </>}
          </div>}


          {formData?.basicDetails?.lookingTo == "PG" && <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="mb-8">
              <label className="block text-md font-semibold text-gray-700 mb-2">Room Occupancy</label>
              <select
                name="aboutProperty.RoomOccupancy"
                value={formData?.aboutProperty?.RoomOccupancy}
                onChange={handleChange1}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="" disabled>Select</option>
                <option value="Single">Single</option>
                <option value="Double">Double</option>
                <option value="Triple">Triple</option>
              </select>
            </div>
          </div>}


          {formData?.basicDetails?.lookingTo == "PG" && <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="mb-8">
              <label className="block text-md font-semibold text-gray-700 mb-2">Room Type</label>
              <select
                name="aboutProperty.RoomType"
                value={formData?.aboutProperty?.RoomType}
                onChange={handleChange1}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              >
                <option value="" disabled>Select</option>
                <option value="Sharing">Sharing</option>
                <option value="Private">Private</option>
              </select>
            </div>
          </div>}

          {formData?.basicDetails?.lookingTo == "PG" && <div className="mb-8">
            <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
              Capacity and Availability
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
              <div className="flex items-center">
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700">Total No Of Beds in PG</label>
                  <input
                    type="number"
                    name="aboutProperty.capacityAvailability.totalBeds" // Nested inside aboutProperty.capacityAvailability
                    value={formData.aboutProperty?.capacityAvailability?.totalBeds || ""} // Safe access
                    onChange={(e) => {
                      const { name, value } = e.target;
                      setFormData((prevState) => {
                        const updatedState = { ...prevState };
                        const fields = name.split("."); // Split the field name for nested structure
                        let currentSection = updatedState;

                        for (let i = 0; i < fields.length - 1; i++) {
                          if (!currentSection[fields[i]]) {
                            currentSection[fields[i]] = {}; // Create missing sections
                          }
                          currentSection = currentSection[fields[i]];
                        }

                        currentSection[fields[fields.length - 1]] = value; // Set the final value
                        return updatedState;
                      });
                    }}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    placeholder="Enter the number of beds"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-4 mt-1">
              {["Attached Bathroom", "Attached Balcony"].map((item, index) => (
                <div key={index} className="flex items-center mb-4">
                  <input
                    type="checkbox"
                    name={`aboutProperty.capacityAvailability.features.${item}`} // Nested inside aboutProperty.capacityAvailability.features
                    checked={
                      formData?.aboutProperty?.capacityAvailability?.features?.includes(item) || false
                    } // Check if the item is selected
                    onChange={(e) => {
                      const { checked } = e.target; // Get the checkbox status

                      setFormData((prevState) => {
                        const updatedState = { ...prevState };
                        let features =
                          updatedState.aboutProperty?.capacityAvailability?.features || [];

                        // Add or remove the item based on the checkbox status
                        if (checked) {
                          features = [...features, item];
                        } else {
                          features = features.filter((i) => i !== item);
                        }

                        // Update the features array in the state
                        updatedState.aboutProperty.capacityAvailability.features = features;
                        return updatedState;
                      });
                    }}
                    className="mr-2 h-5 w-5 align-middle"
                  />
                  <label htmlFor={`aboutProperty.capacityAvailability.${item.toLowerCase()}`} className="text-sm">
                    {item}
                  </label>
                </div>
              ))}
            </div>
          </div>}

          {(formData?.basicDetails?.lookingTo == "PG" || formData?.basicDetails?.lookingTo == "Sell") && formData?.basicDetails?.propertyType !== "Commercial" &&
            formData?.basicDetails?.propertyType !== "agriculture" && (<div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                Floors Allowed for Construction
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                <div className="flex items-center">
                  <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700">No. of Floors</label>
                    <input
                      type="number"
                      name="aboutProperty.constructionDetails.floorsAllowed" // Nested inside aboutProperty.constructionDetails
                      value={formData.aboutProperty?.constructionDetails?.floorsAllowed || ""} // Safe access
                      onChange={(e) => {
                        const { name, value } = e.target;
                        setFormData((prevState) => {
                          const updatedState = { ...prevState };
                          const fields = name.split("."); // Split the field name for nested structure
                          let currentSection = updatedState;

                          for (let i = 0; i < fields.length - 1; i++) {
                            if (!currentSection[fields[i]]) {
                              currentSection[fields[i]] = {}; // Create missing sections
                            }
                            currentSection = currentSection[fields[i]];
                          }

                          currentSection[fields[fields.length - 1]] = value; // Set the final value
                          return updatedState;
                        });
                      }}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      placeholder="Enter the number of floors"
                    />
                  </div>
                </div>
              </div>
            </div>)}







          {(formData?.basicDetails?.lookingTo !== "PG" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-8">
            <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">Width of facing road</label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div className="flex items-center">
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700">Enter the Width</label>
                  <input
                    type="number"
                    name="aboutProperty.roadDetails.roadWidth"
                    value={formData.aboutProperty?.roadDetails?.roadWidth || ""}
                    onChange={handleChange1}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    placeholder="Enter Road Width"
                  />
                </div>
                <div className="ml-2 w-32">
                  <label className="block text-sm font-medium text-gray-700">Unit</label>
                  <select
                    name="aboutProperty.roadDetails.roadWidthUnit"
                    value={formData.aboutProperty?.roadDetails?.roadWidthUnit || "sq.ft"}
                    onChange={handleChange1}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  >
                    <option value="sq.ft">sq.ft</option>
                    <option value="sq.yards">sq.yards</option>
                    <option value="m²">m²</option>
                    <option value="acres">acres</option>
                  </select>
                </div>
              </div>
            </div>
          </div>}



          {(formData?.basicDetails?.lookingTo !== "PG" && formData?.basicDetails?.additionalOption?.key == "plot_land" && formData?.basicDetails?.propertyType !== "agriculture") && (
            <div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                Property Dimensions (Optional)
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-center">
                  <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700">Length of plot (in Ft.)</label>
                    <input
                      type="number"
                      name="aboutProperty.propertyDimensions.length" // Nested under aboutProperty.propertyDimensions.length
                      value={formData.aboutProperty?.propertyDimensions?.length || ""} // Safe access
                      onChange={(e) => {
                        const { name, value } = e.target;
                        setFormData((prevState) => {
                          const updatedState = { ...prevState };
                          const fields = name.split(".");
                          let currentSection = updatedState;

                          for (let i = 0; i < fields.length - 1; i++) {
                            if (!currentSection[fields[i]]) {
                              currentSection[fields[i]] = {};
                            }
                            currentSection = currentSection[fields[i]];
                          }

                          currentSection[fields[fields.length - 1]] = value;
                          return updatedState;
                        });
                      }}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      placeholder="Enter Length"
                    />
                  </div>
                  <div className="ml-2 w-[200px]">
                    <label className="block text-sm font-medium text-gray-700 whitespace-nowrap">
                      Breadth of plot (in Ft.)
                    </label>
                    <input
                      type="number"
                      name="aboutProperty.propertyDimensions.breadth" // Nested under aboutProperty.propertyDimensions.breadth
                      value={formData.aboutProperty?.propertyDimensions?.breadth || ""} // Safe access
                      onChange={(e) => {
                        const { name, value } = e.target;
                        setFormData((prevState) => {
                          const updatedState = { ...prevState };
                          const fields = name.split(".");
                          let currentSection = updatedState;

                          for (let i = 0; i < fields.length - 1; i++) {
                            if (!currentSection[fields[i]]) {
                              currentSection[fields[i]] = {};
                            }
                            currentSection = currentSection[fields[i]];
                          }

                          currentSection[fields[fields.length - 1]] = value;
                          return updatedState;
                        });
                      }}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      placeholder="Enter Breadth"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}



          {(formData?.basicDetails?.lookingTo !== "PG" && formData?.basicDetails?.additionalOption?.key === "plot_land" && formData?.basicDetails?.propertyType !== "agriculture") && (
            <div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                Is there a boundary wall around the property?
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700"></label>
                  <select
                    name="aboutProperty.boundaryWallStatus" // Properly nested key in aboutProperty
                    value={formData.aboutProperty?.boundaryWallStatus || ""} // Safely access the value
                    onChange={(e) => {
                      const { name, value } = e.target;
                      setFormData((prevState) => {
                        const updatedState = { ...prevState };
                        const fields = name.split(".");
                        let currentSection = updatedState;

                        for (let i = 0; i < fields.length - 1; i++) {
                          if (!currentSection[fields[i]]) {
                            currentSection[fields[i]] = {};
                          }
                          currentSection = currentSection[fields[i]];
                        }

                        currentSection[fields[fields.length - 1]] = value;
                        return updatedState;
                      });
                    }}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  >
                    <option value="">Select an option</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>
            </div>
          )}


          {(formData?.basicDetails?.lookingTo !== "PG" && formData?.basicDetails?.additionalOption?.key === "plot_land" && formData?.basicDetails?.propertyType !== "agriculture") && (
            <div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                No. of open sides
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700"></label>
                  <select
                    name="aboutProperty.openSides" // Nested key in aboutProperty
                    value={formData.aboutProperty?.openSides || ""} // Safely access the value
                    onChange={(e) => {
                      const { name, value } = e.target;
                      setFormData((prevState) => {
                        const updatedState = { ...prevState };
                        const fields = name.split(".");
                        let currentSection = updatedState;

                        for (let i = 0; i < fields.length - 1; i++) {
                          if (!currentSection[fields[i]]) {
                            currentSection[fields[i]] = {};
                          }
                          currentSection = currentSection[fields[i]];
                        }

                        currentSection[fields[fields.length - 1]] = value;
                        return updatedState;
                      });
                    }}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  >
                    <option value="">Select number of open sides</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </select>
                </div>
              </div>
            </div>
          )}


          {(formData?.basicDetails?.lookingTo !== "PG" && formData?.basicDetails?.additionalOption?.key === "plot_land" && formData?.basicDetails?.propertyType !== "agriculture") && (
            <div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                Any construction done on this property?
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700"></label>
                  <select
                    name="aboutProperty.constructionDone" // Nested key in aboutProperty
                    value={formData.aboutProperty?.constructionDone || ""} // Safely access the value
                    onChange={(e) => {
                      const { name, value } = e.target;
                      setFormData((prevState) => {
                        const updatedState = { ...prevState };
                        const fields = name.split(".");
                        let currentSection = updatedState;

                        for (let i = 0; i < fields.length - 1; i++) {
                          if (!currentSection[fields[i]]) {
                            currentSection[fields[i]] = {};
                          }
                          currentSection = currentSection[fields[i]];
                        }

                        currentSection[fields[fields.length - 1]] = value;
                        return updatedState;
                      });
                    }}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  >
                    <option value="">Select an option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
            </div>
          )}









          {(formData?.basicDetails?.lookingTo !== "PG" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-8">
            <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">Property Facing</label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <select
                  name="aboutProperty.propertyFacing" // Now linked to aboutProperty.propertyFacing
                  value={formData?.aboutProperty?.propertyFacing || ""} // Value from formData
                  onChange={handleChange1} // Updates state on input change
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"

                >
                  <option value="North">North</option>
                  <option value="South">South</option>
                  <option value="East">East</option>
                  <option value="West">West</option>
                  <option value="North-East">North-East</option>
                  <option value="North-West">North-West</option>
                  <option value="South-East">South-East</option>
                  <option value="South-West">South-West</option>
                </select>
              </div>
            </div>
          </div>}



          {(formData?.basicDetails?.lookingTo !== "PG" && formData?.basicDetails?.additionalOption?.key !== "plot_land" &&
            formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                Other rooms (Optional)
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                {["Pooja Room", "Study Room", "Servant Room", "Store Room"].map((room) => (
                  <div key={room} className="flex items-center">
                    <input
                      type="checkbox"
                      name="aboutProperty.otherRooms" // Updated to refer to aboutProperty.otherRooms
                      value={room}
                      checked={formData?.aboutProperty?.otherRooms?.includes(room)} // Checks if the option is selected
                      onChange={(e) => {
                        const updatedRooms = e.target.checked
                          ? [...formData.aboutProperty.otherRooms, room] // Add room if checked
                          : formData.aboutProperty.otherRooms.filter((r) => r !== room); // Remove room if unchecked
                        handleChange({
                          target: {
                            name: "aboutProperty.otherRooms", // Referencing updated field
                            value: updatedRooms,
                          },
                        });
                      }}
                      className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                      disabled={formData?.propertyType === "PG"} // Disables if propertyType is PG
                    />
                    <label htmlFor={room} className="ml-2 text-sm font-medium text-gray-700">
                      {room}
                    </label>
                  </div>
                ))}
              </div>
            </div>}






          {(formData?.basicDetails?.additionalOption?.key !== "plot_land" &&
            formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                Furnishing
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                <div>
                  <select
                    name="aboutProperty.furnishings.status" // Linking to aboutProperty.furnishings.status
                    value={formData?.aboutProperty?.furnishings?.status || ""} // Safe access with optional chaining
                    onChange={(e) => {
                      const { value } = e.target;

                      setFormData((prevState) => {
                        return {
                          ...prevState,
                          aboutProperty: {
                            ...prevState.aboutProperty,
                            furnishings: {
                              ...prevState.aboutProperty.furnishings,
                              status: value, // Update the status field
                              features: value === "Furnished" || value === "Semi-Furnished" ? prevState.aboutProperty.furnishings.features : {
                                light: "",
                                fans: "",
                                ac: "",
                                tv: "",
                                geyser: "",
                                beds: "",
                                wardrobe: "",
                                otherItems: [], // Reset all features if status is not "Furnished" or "Semi-Furnished"
                              },
                            },
                          },
                        };
                      });
                    }} // Handle furnishing status change
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    disabled={formData?.propertyType === "PG"} // Disabled when propertyType is "PG"
                  >
                    <option value="">Select</option>
                    <option value="Furnished">Furnished</option>
                    <option value="Semi-Furnished">Semi-Furnished</option>
                    <option value="Un-Furnished">Un-Furnished</option>
                  </select>
                </div>
              </div>

              {/* Furnishings Details (Visible only when "Furnished" or "Semi-Furnished" is selected) */}
              {(formData?.aboutProperty?.furnishings?.status === "Furnished" || formData?.aboutProperty?.furnishings?.status === "Semi-Furnished") && (
                <>
                  <div className="text-center mt-8">
                    <p>At least three furnishings are mandatory for furnished</p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mt-4">
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Light</label>
                      <input
                        type="text"
                        name="aboutProperty.furnishings.features.light" // Linked to aboutProperty.furnishings.features.light
                        value={formData?.aboutProperty?.furnishings?.features?.light || ""}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          const fields = name.split("."); // Split by dots to handle nested fields

                          setFormData((prevState) => {
                            let updatedState = { ...prevState };
                            let currentSection = updatedState;

                            for (let i = 0; i < fields.length - 1; i++) {
                              if (!currentSection[fields[i]]) {
                                currentSection[fields[i]] = {};  // Create missing sections
                              }
                              currentSection = currentSection[fields[i]];  // Move deeper into the object
                            }

                            // Update the final field with the new value
                            currentSection[fields[fields.length - 1]] = value;

                            return updatedState;
                          });
                        }}

                        placeholder="Enter Light details"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Fans</label>
                      <input
                        type="text"
                        name="aboutProperty.furnishings.features.fans" // Linked to aboutProperty.furnishings.features.fans
                        value={formData?.aboutProperty?.furnishings?.features?.fans || ""}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          const fields = name.split("."); // Split by dots to handle nested fields

                          setFormData((prevState) => {
                            let updatedState = { ...prevState };
                            let currentSection = updatedState;

                            for (let i = 0; i < fields.length - 1; i++) {
                              if (!currentSection[fields[i]]) {
                                currentSection[fields[i]] = {};  // Create missing sections
                              }
                              currentSection = currentSection[fields[i]];  // Move deeper into the object
                            }

                            // Update the final field with the new value
                            currentSection[fields[fields.length - 1]] = value;

                            return updatedState;
                          });
                        }}
                        placeholder="Enter Fans details"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">AC</label>
                      <input
                        type="text"
                        name="aboutProperty.furnishings.features.ac" // Linked to aboutProperty.furnishings.features.ac
                        value={formData?.aboutProperty?.furnishings?.features?.ac || ""}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          const fields = name.split("."); // Split by dots to handle nested fields

                          setFormData((prevState) => {
                            let updatedState = { ...prevState };
                            let currentSection = updatedState;

                            for (let i = 0; i < fields.length - 1; i++) {
                              if (!currentSection[fields[i]]) {
                                currentSection[fields[i]] = {};  // Create missing sections
                              }
                              currentSection = currentSection[fields[i]];  // Move deeper into the object
                            }

                            // Update the final field with the new value
                            currentSection[fields[fields.length - 1]] = value;

                            return updatedState;
                          });
                        }}
                        placeholder="Enter AC details"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">TV</label>
                      <input
                        type="text"
                        name="aboutProperty.furnishings.features.tv" // Linked to aboutProperty.furnishings.features.tv
                        value={formData?.aboutProperty?.furnishings?.features?.tv || ""}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          const fields = name.split("."); // Split by dots to handle nested fields

                          setFormData((prevState) => {
                            let updatedState = { ...prevState };
                            let currentSection = updatedState;

                            for (let i = 0; i < fields.length - 1; i++) {
                              if (!currentSection[fields[i]]) {
                                currentSection[fields[i]] = {};  // Create missing sections
                              }
                              currentSection = currentSection[fields[i]];  // Move deeper into the object
                            }

                            // Update the final field with the new value
                            currentSection[fields[fields.length - 1]] = value;

                            return updatedState;
                          });
                        }}
                        placeholder="Enter TV details"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Geyser</label>
                      <input
                        type="text"
                        name="aboutProperty.furnishings.features.geyser" // Linked to aboutProperty.furnishings.features.geyser
                        value={formData?.aboutProperty?.furnishings?.features?.geyser || ""}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          const fields = name.split("."); // Split by dots to handle nested fields

                          setFormData((prevState) => {
                            let updatedState = { ...prevState };
                            let currentSection = updatedState;

                            for (let i = 0; i < fields.length - 1; i++) {
                              if (!currentSection[fields[i]]) {
                                currentSection[fields[i]] = {};  // Create missing sections
                              }
                              currentSection = currentSection[fields[i]];  // Move deeper into the object
                            }

                            // Update the final field with the new value
                            currentSection[fields[fields.length - 1]] = value;

                            return updatedState;
                          });
                        }}
                        placeholder="Enter Geyser details"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Beds</label>
                      <input
                        type="text"
                        name="aboutProperty.furnishings.features.beds" // Linked to aboutProperty.furnishings.features.beds
                        value={formData?.aboutProperty?.furnishings?.features?.beds || ""}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          const fields = name.split("."); // Split by dots to handle nested fields

                          setFormData((prevState) => {
                            let updatedState = { ...prevState };
                            let currentSection = updatedState;

                            for (let i = 0; i < fields.length - 1; i++) {
                              if (!currentSection[fields[i]]) {
                                currentSection[fields[i]] = {};  // Create missing sections
                              }
                              currentSection = currentSection[fields[i]];  // Move deeper into the object
                            }

                            // Update the final field with the new value
                            currentSection[fields[fields.length - 1]] = value;

                            return updatedState;
                          });
                        }}
                        placeholder="Enter Beds details"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700">Wardrobe</label>
                      <input
                        type="text"
                        name="aboutProperty.furnishings.features.wardrobe" // Linked to aboutProperty.furnishings.features.wardrobe
                        value={formData?.aboutProperty?.furnishings?.features?.wardrobe || ""}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          const fields = name.split("."); // Split by dots to handle nested fields

                          setFormData((prevState) => {
                            let updatedState = { ...prevState };
                            let currentSection = updatedState;

                            for (let i = 0; i < fields.length - 1; i++) {
                              if (!currentSection[fields[i]]) {
                                currentSection[fields[i]] = {};  // Create missing sections
                              }
                              currentSection = currentSection[fields[i]];  // Move deeper into the object
                            }

                            // Update the final field with the new value
                            currentSection[fields[fields.length - 1]] = value;

                            return updatedState;
                          });
                        }}
                        placeholder="Enter Wardrobe details"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      />
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-x-6 gap-y-4 mt-1">
                    {["Sofa", "Washing Machine", "Stove", "Fridge", "Water Purifier", "Microwave", "Modular Kitchen", "Chimney", "Dinning Table", "Curtains", "Exhaust Fan"].map((item, index) => (
                      <div key={index} className="flex items-center mb-4">
                        <input
                          type="checkbox"
                          name={`aboutProperty.furnishings.features.otherItems.${item}`} // Dynamically set name for each item
                          checked={formData?.aboutProperty?.furnishings?.features?.otherItems?.includes(item) || false} // Check if the item is in the array
                          onChange={(e) => {
                            const { checked } = e.target; // Extract checked status from input

                            setFormData((prevState) => {
                              // Clone the current formData state
                              let updatedState = { ...prevState };
                              let currentOtherItems = updatedState?.aboutProperty?.furnishings?.features?.otherItems || []; // Safe access with optional chaining

                              // Update the array by adding or removing the item based on the checkbox status
                              if (checked) {
                                currentOtherItems = [...currentOtherItems, item];
                              } else {
                                currentOtherItems = currentOtherItems.filter((i) => i !== item);
                              }

                              // Set the updated otherItems array back to the state
                              updatedState.aboutProperty.furnishings.features.otherItems = currentOtherItems;
                              return updatedState;
                            });
                          }}
                          className="mr-2 h-5 w-5 align-middle"
                        />
                        <label htmlFor={`aboutProperty.furnishings.features.${item.toLowerCase()}Checked`} className="text-sm">{item}</label>
                      </div>
                    ))}
                  </div>

                </>
              )}
            </div>
          }



          {(formData?.basicDetails?.lookingTo !== "PG" && formData?.basicDetails?.additionalOption?.key !== "plot_land" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-8">
            <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">Reserved Parking (Optional)</label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Covered Parking</label>
                <input
                  type="text"
                  name="aboutProperty.parking.coveredParking" // Nested inside aboutProperty.parking
                  value={formData?.aboutProperty?.parking?.coveredParking || ""} // Safe access with optional chaining
                  onChange={handleChange} // Handle change for covered parking
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  placeholder="Enter Covered Parking details"
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Open Parking</label>
                <input
                  type="text"
                  name="aboutProperty.parking.openParking" // Nested inside aboutProperty.parking
                  value={formData?.aboutProperty?.parking?.openParking || ""} // Safe access with optional chaining
                  onChange={handleChange} // Handle change for open parking
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  placeholder="Enter Open Parking details"
                />
              </div>
            </div>
          </div>}





          {(formData?.basicDetails?.additionalOption?.key !== "plot_land" &&
            formData?.basicDetails?.propertyType !== "Commercial") && <div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">Floor Details</label>
              <p>Total no of floors and your floor details</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">Total Floor</label>
                  <input
                    type="text"
                    name="aboutProperty.floorDetails.totalFloor" // Updated path to include aboutProperty
                    value={formData?.aboutProperty?.floorDetails?.totalFloor || ""}
                    onChange={handleChange}
                    placeholder="Enter total number of floors" // Added placeholder
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">Property On Floor</label>
                  <select
                    name="aboutProperty.floorDetails.propertyOnFloor" // Updated path to include aboutProperty
                    value={formData?.aboutProperty?.floorDetails?.propertyOnFloor || ""}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  >
                    <option value="">Select the floor</option> {/* Default option */}
                    {floorOptions.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-gray-700 font-medium text-sm">BHK Type</label>
                  <select
                    name="aboutProperty.floorDetails.bhkType"
                    value={formData?.aboutProperty?.floorDetails?.bhkType}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    required
                  >
                    <option value="">Select BHK Type</option>
                    <option value="1 BHK">1 BHK</option>
                    <option value="2 BHK">2 BHK</option>
                    <option value="3 BHK">3 BHK</option>
                    <option value="4 BHK">4 BHK</option>
                  </select>
                </div>
              </div>
            </div>
          }




          {(formData?.basicDetails?.lookingTo !== "PG" && formData?.basicDetails?.additionalOption?.key !== "plot_land") && <div className="mb-8">
            <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
              Availability Status
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <select
                  name="aboutProperty.availabilityStatus" // Key in formData under aboutProperty
                  value={formData?.aboutProperty?.availabilityStatus || ""} // Safe access with optional chaining
                  onChange={handleChange} // Update state on change
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                >
                  <option value="" disabled>Select Availability</option> {/* Default option */}
                  <option value="Ready To Move">Ready To Move</option>
                  <option value="Under Construction">Under Construction</option>
                </select>
              </div>
            </div>
          </div>}



          {(formData?.basicDetails?.lookingTo !== "PG" &&
            formData?.aboutProperty?.availabilityStatus == "Under Construction" && 
            formData?.basicDetails?.lookingTo !== "Rent / Lease" &&
            formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                Possession By
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Expected By</label>
                  <select
                    name="aboutProperty.possessionBy.expectedBy"
                    value={formData?.aboutProperty?.possessionBy?.expectedBy || ""}
                    onChange={handleYearChange} // Custom handle change for year selection
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  >
                    <option value="" disabled>Select Possession Time</option>
                    <option value="Within 3 Months">Within 3 Months</option>
                    <option value="Within 6 Months">Within 6 Months</option>
                    <option value="2025">By 2025</option>
                    <option value="2026">By 2026</option>
                    {/* You can add more years as per your requirements */}
                  </select>
                </div>

                {isYearSelected && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Month</label>
                    <select
                      name="aboutProperty.possessionBy.month"
                      value={formData?.aboutProperty?.possessionBy?.month || ""}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                      <option value="" disabled>Select Month</option>
                      {filterMonths().map((month, index) => (
                        <option key={index} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>}

          {(formData?.basicDetails?.lookingTo !== "Sell" || formData?.basicDetails?.propertyType === "agriculture") && <div className="mb-8">
            <label htmlFor="availableFrom" className="block text-md font-semibold text-gray-700 mb-2">
              Available From
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 ">
              <div>
                <input
                  type="date"
                  id="availableFrom"
                  name="aboutProperty.availableFrom" // Updated to be inside aboutProperty
                  value={formData?.aboutProperty?.availableFrom ? new Date(formData?.aboutProperty?.availableFrom).toISOString().split('T')[0] : ''} // Convert timestamp to date format
                  onChange={(e) => {
                    const timestamp = new Date(e.target.value).getTime(); // Convert the selected date to timestamp
                    handleChange({
                      target: {
                        name: 'aboutProperty.availableFrom',
                        value: timestamp, // Set the timestamp as value
                      },
                    });
                  }} // Update state with timestamp
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              </div>
            </div>
          </div>
          }



          {(formData?.basicDetails?.lookingTo !== "PG" && formData?.basicDetails?.lookingTo !== "Sell" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-8">
            <label className="block text-md font-semibold text-gray-700 mb-2">
              Willing to Rent Out To
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {["Family", "Single Men", "Single Women"].map((option) => (
                <div key={option} className="flex items-center">
                  <input
                    type="checkbox"
                    id={option}
                    name="aboutProperty.willingToRentOutTo" // Nested inside aboutProperty
                    value={option}
                    checked={formData?.aboutProperty?.willingToRentOutTo?.includes(option)} // Check if the option is selected
                    onChange={(e) => {
                      const updatedOptions = e.target.checked
                        ? [...(formData?.aboutProperty?.willingToRentOutTo || []), option] // Add option if checked
                        : formData?.aboutProperty?.willingToRentOutTo?.filter((item) => item !== option); // Remove option if unchecked

                      handleChange({
                        target: {
                          name: "aboutProperty.willingToRentOutTo", // Update the willingToRentOutTo array
                          value: updatedOptions,
                        },
                      });
                    }} // Update state for willingToRentOutTo array
                    className="h-4 w-4 border-gray-300 rounded"
                  />
                  <label htmlFor={option} className="ml-2 text-sm text-gray-700">
                    {option}
                  </label>
                </div>
              ))}
            </div>
          </div>}


          {formData?.basicDetails?.lookingTo == "PG" && <div className="mb-8">
            <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
              Available for
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <select
                  name="aboutProperty.availableFor" // Key in formData under aboutProperty
                  value={formData?.aboutProperty?.availableFor || ""} // Safe access with optional chaining
                  onChange={handleChange} // Update state on change
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                >
                  <option value="" disabled>Select</option> {/* Default option */}
                  <option value="Boys">Boys</option>
                  <option value="Girls">Girls</option>
                  <option value="Any">Any</option>
                </select>
              </div>
            </div>
          </div>}


          {(formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") &&
            <div className="mb-8">
              <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                Suitable for
              </label>
              <div className="flex flex-wrap gap-x-6 gap-y-4 mt-1">
                {["Students", "Working Professionals"].map((item, index) => {
                  const checkboxName = item.toLowerCase().replace(/\s/g, ""); // Convert to lowercase and remove spaces

                  return (
                    <div key={index} className="flex items-center mb-4">
                      <input
                        type="checkbox"
                        name={`aboutProperty.suitableFor.${checkboxName}`} // Nested inside aboutProperty.suitableFor
                        checked={formData?.aboutProperty?.suitableFor?.[checkboxName] || false} // Bind to state
                        onChange={(e) => {
                          const updatedSuitableFor = { ...formData?.aboutProperty?.suitableFor };
                          if (e.target.checked) {
                            updatedSuitableFor[checkboxName] = true; // Set to true if checked
                          } else {
                            delete updatedSuitableFor[checkboxName]; // Remove key if unchecked
                          }

                          handleChange({
                            target: {
                              name: "aboutProperty.suitableFor", // Update the suitableFor object
                              value: updatedSuitableFor, // Pass the updated object
                            },
                          });
                        }} // Update state for suitableFor object
                        className="mr-2 h-5 w-5 align-middle"
                      />
                      <label htmlFor={checkboxName} className="text-sm">
                        {item}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
            <div className="flex items-center">
              <input
                id="corner-property"
                type="checkbox"
                name="aboutProperty.CornerProperty"
                checked={formData?.aboutProperty?.CornerProperty || false}
                onChange={(e) => {
                  handleChange({
                    target: {
                      name: "aboutProperty.CornerProperty",
                      value: e.target.checked, // Sets true or false
                    },
                  });
                }}
                className="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <label
                htmlFor="corner-property"
                className="ml-2 text-sm font-medium text-gray-800 cursor-pointer"
              >
                Corner Property
              </label>
            </div>
          </div>









        </fieldset>


        {/* Section 4: Upload Images */}
        <fieldset className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Videos & Photos</legend>
          <UploadComponent files={formData.mediaFiles} onFileUpdate={handleFileUpdate} />
        </fieldset>


        <fieldset className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Pricing & Others</legend>
          {((formData.basicDetails?.lookingTo == "PG" || formData.basicDetails?.lookingTo == "Rent / Lease")) &&
            <>
              <div className="mb-8">
                <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                  Rent Details
                </label>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 ">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">₹ Expected Rent</label>
                    <input
                      type="text"
                      id="availableFrom"
                      placeholder="₹ Expected Rent"
                      name="pricingAndOthers.rentDetails.expectedRent"
                      value={formData?.pricingAndOthers?.rentDetails?.expectedRent || ""}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                  </div>
                </div>

                {(formData.basicDetails?.lookingTo == "Rent / Lease") && <div className="mt-1 space-y-2">
                  {[
                    { id: "electricityWaterExclude", label: "Electricity & Water charges excluded" },
                    { id: "priceNegotiable", label: "Price Negotiable" },
                  ].map(({ id, label }) => (
                    <div key={id} className="flex items-center">
                      <input
                        type="checkbox"
                        id={id}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        checked={formData?.pricingAndOthers?.rentDetails[id]}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            pricingAndOthers: {
                              ...prev.pricingAndOthers,
                              rentDetails: {
                                ...(prev.pricingAndOthers?.rentDetails || {}),
                                [id]: e.target.checked,
                              },
                            },
                          }));
                        }}
                      />
                      <label htmlFor={id} className="ml-2 text-sm text-gray-700">
                        {label}
                      </label>
                    </div>
                  ))}
                </div>}


                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Additional Rent Details (Optional)</label>
                    <div className="flex items-center mb-2">
                      <div className="w-full">
                        <input
                          type="number"
                          name="pricingAndOthers.rentDetails.maintenance"
                          value={formData?.pricingAndOthers?.rentDetails?.maintenance || ""}
                          onChange={handleChange}
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                          placeholder="Enter Maintenance"
                        />
                      </div>
                      <div className="ml-2 w-32">
                        <select
                          name="pricingAndOthers.rentDetails.maintenanceUnit"
                          value={formData?.pricingAndOthers?.rentDetails?.maintenanceUnit || ""}
                          onChange={handleChange}
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        >
                          <option value="Monthly">Monthly</option>
                          <option value="Annually">Annually</option>
                          <option value="One Time">One Time</option>
                          <option value="Per Unit/Monthly">Per Unit/Monthly</option>
                        </select>
                      </div>
                    </div>
                    <div className="flex items-center mb-2">
                      <div className="w-full">
                        <input
                          type="number"
                          name="pricingAndOthers.rentDetails.bookingAmount"
                          value={formData?.pricingAndOthers?.rentDetails?.bookingAmount || ""}
                          onChange={handleChange}
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                          placeholder="Enter Booking Amount"
                        />
                      </div>
                    </div>

                    <div className="flex items-center mb-2">
                      <div className="w-full">
                        <input
                          type="number"
                          name="pricingAndOthers.rentDetails.membershipCharge"
                          value={formData?.pricingAndOthers?.rentDetails?.membershipCharge || ""}
                          onChange={handleChange}
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                          placeholder="Enter Membership charge"
                        />
                      </div>
                    </div>
                  </div>
                </div>


              </div>


              <div className="mb-3">
                <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                  Security deposit  (Optional)
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 ">
                  <div className="mb-8">
                    <select
                      name="pricingAndOthers.securityDeposit.type"
                      value={formData?.pricingAndOthers?.securityDeposit?.type || ""}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                      <option value="" disabled>Select</option>
                      <option value="Fixed">Fixed</option>
                      <option value="Multiple of Rent">Multiple of Rent</option>
                      <option value="None">None</option>
                    </select>
                    {formData?.pricingAndOthers?.securityDeposit?.type == "Fixed" && <div className="mt-2">
                      <label className="block text-sm font-medium text-gray-700">Deposit value</label>
                      <input
                        type="number"
                        id="availableFrom"
                        placeholder="Deposit value"

                        name="pricingAndOthers.securityDeposit.depositValue"
                        value={formData?.pricingAndOthers?.securityDeposit?.depositValue || ""}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      />
                    </div>}

                    {formData?.pricingAndOthers?.securityDeposit?.type == "Multiple of Rent" && <div className="mt-2">
                      <label className="block text-sm font-medium text-gray-700">No. of Months (Max 30)</label>
                      <input
                        type="text"
                        id="availableFrom"
                        placeholder="No. of Months (Max 30)"
                        name="pricingAndOthers.securityDeposit.noOfMonths"
                        value={formData?.pricingAndOthers?.securityDeposit?.noOfMonths || ""}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      />
                    </div>}
                  </div>
                </div>

              </div>



              {(formData.basicDetails?.lookingTo == "PG") && <div className="mb-8">
                <label htmlFor="" className="block text-md font-semibold text-gray-700 mb-2">
                  Total price includes
                </label>
                <div className="flex flex-wrap gap-4 ">
                  {amenities.map((amenity) => (
                    <button
                      type="button"
                      key={amenity}
                      onClick={() => {
                        setFormData((prevState) => {
                          const updatedSelections =
                            amenity === "None of the above"
                              ? prevState.pricingAndOthers?.totalPriceIncludes?.includes("None of the above")
                                ? []
                                : ["None of the above"]
                              : prevState.pricingAndOthers?.totalPriceIncludes?.filter(
                                (item) => item !== "None of the above"
                              ) || [];

                          const newSelections = updatedSelections.includes(amenity)
                            ? updatedSelections.filter((item) => item !== amenity)
                            : [...updatedSelections, amenity];

                          return {
                            ...prevState,
                            pricingAndOthers: {
                              ...prevState.pricingAndOthers,
                              totalPriceIncludes: newSelections,
                            },
                          };
                        });
                      }}
                      className={`flex items-center text-[14px] gap-2 px-2 py-[2px] border rounded-full text-gray-500 
                    ${formData.pricingAndOthers?.totalPriceIncludes?.includes(amenity)
                          ? "bg-blue-50 border-blue-500 text-blue-600"
                          : "border-gray-300 hover:border-blue-500 hover:text-blue-500"
                        }`}
                    >
                      {formData.pricingAndOthers?.totalPriceIncludes?.includes(amenity) && (
                        <FaCheck className="text-blue-500" />
                      )}
                      {formData.pricingAndOthers?.totalPriceIncludes?.includes(amenity) ? amenity : `+ ${amenity}`}
                    </button>
                  ))}
                </div>

                <ServicesExcludingPrice formData={formData} setFormData={setFormData} />
                <FoodDetails formData={formData} setFormData={setFormData} />
                <ContractForm
                  setFormData={setFormData}
                />
              </div>}

              {/* Property Description */}
              {(formData.basicDetails?.lookingTo == "Rent / Lease") &&
                <>
                  {/* Minimum Contract Duration */}
                  <div className="grid grid-cols-1 md:grid-cols-2">
                    <div className="mb-4">
                      <label className="block text-sm font-medium mb-2">Minimum contract duration (Optional)</label>
                      <select
                        className="w-full border rounded-md px-3 py-2"
                        name="pricingAndOthers.rentDetails.minDuration"
                        value={formData?.pricingAndOthers?.rentDetails?.minDuration}
                        onChange={handleChange}
                      >
                        {[...Array(12).keys()].map((num) => (
                          <option key={num} value={num + 1}>
                            {num + 1} month{num > 0 ? "s" : ""}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Months of Notice */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium mb-2">Months of Notice (Optional)</label>
                    <div className="flex gap-2 flex-wrap">
                      {["None", "1 month", "2 months", "3 months", "4 months", "5 months", "6 months"].map((option) => (
                        <button
                          type="button"
                          key={option}
                          className={`px-2 py-1 text-sm border rounded-md ${formData?.pricingAndOthers?.rentDetails?.noticePeriod === option ? "bg-blue-500 text-white" : "bg-white text-gray-700"
                            }`}
                          onClick={() => {
                            setFormData((prev) => ({
                              ...prev,
                              pricingAndOthers: {
                                ...prev.pricingAndOthers,
                                rentDetails: {
                                  ...(prev.pricingAndOthers?.rentDetails || {}),
                                  noticePeriod: option,
                                },
                              },
                            }));
                          }}


                        >
                          {option}
                        </button>
                      ))}
                    </div>
                  </div>


                  <div className="mb-4">
                    <label className="block text-sm font-medium mb-2">What makes your property unique</label>
                    <textarea
                      className="w-full border rounded-md px-3 py-2"
                      name="pricingAndOthers.rentDetails.propertyDescription"
                      rows={5}
                      placeholder="Share some details about your property like spacious rooms, well-maintained facilities..."
                      value={formData?.pricingAndOthers?.rentDetails?.propertyDescription}
                      onChange={handleChange}
                    ></textarea>
                    <p className="text-sm text-gray-500 mt-1">
                      Minimum 30 characters required <span className="float-right">{formData?.pricingAndOthers?.rentDetails?.propertyDescription?.length}/5000</span>
                    </p>
                  </div>
                </>
              }
            </>}

          {(formData.basicDetails?.lookingTo == "Sell") && <OwnershipPriceDetails formData={formData} setFormData={setFormData} />}


        </fieldset>


        <fieldset className="border border-gray-300 p-4 rounded-md">
          <legend className="text-lg font-semibold px-2">Amenities Section</legend>
          <PropertyFeatures formData={formData} setFormData={setFormData} />
        </fieldset>


        {/* Error Message */}
        {error && <div className="text-red-600 text-sm mt-2">{error}</div>}
        {/* Submit and Cancel Buttons */}
        <div className="mt-6 flex justify-end gap-4">
          <button
            type="button"
            className="bg-gray-500 text-white py-2 px-4 rounded-md shadow-sm hover:bg-gray-600"
            onClick={() => console.log("Cancel clicked")}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`bg-blue-600 text-white py-2 px-6 rounded-md shadow-sm hover:bg-blue-700 ${isLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddPropertySection;
